import axios from "../../../axios";

//Harshada Bhavsar (22/11/2025)
export const getProjectTypes = async () => {
  return axios.get("/api/MetaData/projecttypes");
};

//Harshada Bhavsar (26/11/2025)
export const getRoleTypes = async () => {
  return axios.get("/api/MetaData/roletypes");
};
